
export function isEditable(c: any){
    let state = c && c.state;
    let liveEditedState = c && c.liveEditedState;
    if (state === 'LOCKED' || state === 'DEPARTED' || state === 'OVERNIGHT' || liveEditedState === 'BLESSED'){
        return false
    }
    return true
}